module.exports = __webpack_public_path__ + "img/jcb.e80729be.png";